import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito saber de diseño para usar el pack?',
    a: 'No. Los stickers ya están diseñados y listos. Solo descargás, imprimís y vendés.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibís un email con el link de descarga. Lo tenés en minutos desde cualquier dispositivo.'
  }, {
    q: '¿Necesito una imprenta profesional?',
    a: 'No. Podés imprimir en casa con una impresora hogareña o llevarlo a cualquier imprenta local o copistería del barrio.'
  }, {
    q: '¿Puedo vender los stickers que imprima?',
    a: 'Sí. El pack incluye licencia de uso comercial — imprimís y vendés libremente.'
  }, {
    q: '¿La garantía es real?',
    a: 'Sí. 7 días, 100% del dinero, sin preguntas. Se hace efectiva con un solo email.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-black" data-id="element-47">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-48">
        <h2 className="text-3xl font-extrabold text-center text-white mb-12" data-id="element-49">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-50">
          {faqs.map((faq, i) => <div key={i} className="border border-sky-900/40 rounded-2xl overflow-hidden bg-zinc-900/60" data-id="element-51">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 hover:bg-zinc-900/40 transition-colors" aria-expanded={openIndex === i} data-id="element-52">
                <span className="font-bold text-white pr-4" data-id="element-53">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-sky-300 transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-54" />
              </button>

              <AnimatePresence data-id="element-55">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-56">
                    <div className="px-6 pb-5 text-zinc-200 leading-relaxed border-t border-sky-900/30 pt-3" data-id="element-57">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}